import { GoChevronLeft } from 'react-icons/go'
import { useNavigate } from 'react-router'

const NotFoundSettings: React.FC = () => {
  const navigate = useNavigate()
  return (
    <div className="flex h-full w-full flex-col text-sm">
      <div className="flex h-[50px] items-center pl-[10px] text-xl font-semibold">
        <div className="flex items-center">
          <button
            type="button"
            className="hover-main mr-[10px] flex h-[30px] w-[30px] items-center justify-center rounded-full"
            onClick={() => {
              navigate('/settings')
            }}
          >
            <GoChevronLeft />
          </button>
          <h1>Not found</h1>
        </div>
      </div>
      <div className="text-sub flex h-full w-full items-center justify-center">
        Selected setting option not found.
      </div>
    </div>
  )
}

export default NotFoundSettings
